import { CommonModule, isPlatformBrowser, ViewportScroller} from '@angular/common';
import { ChangeDetectorRef, Component, Inject, inject, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { AuthService } from 'app/core/auth/auth.service';
import { FooterComponent } from '../landing/footer/footer.component';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { PaymentMethodComponent } from '../financials/payment-methods/payment-methods.component';
import { MatMenuModule } from '@angular/material/menu';
import { UpgradePackageComponent } from './package-options/upgrade-package/upgrade-package.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { IResponse } from 'app/core/shared-services/shared-interface.types';
import { SpeedTestComponent } from '../speed-test/speed-test.component';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrdersComponent } from './orders/orders.component';
import { ServicesComponent } from './services/services.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { MandatePopupComponent } from '../financials/debit-orders/mandate-popup/mandate-popup.component';
@Component({
  standalone: true,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [FuseCardComponent, RouterLink, FuseAlertComponent, MatButtonModule, MatIconModule, FooterComponent, ServicesComponent,
    SharedMethodsModule, RouterLink, PaymentMethodComponent, MatMenuModule, UpgradePackageComponent, RouterLink, CommonModule, MatProgressSpinnerModule, MatDialogModule, OrdersComponent, NgxSkeletonLoaderModule]
})

 
export class DashboardComponent  {
  public customerAccount: any;
  public customerLeads: any;
  public customerPaymentDetails: any;
  public validPayment: boolean = true;
  public servicesLength: number;
  public loading: boolean = true;
  public showAddons : boolean = false;

  public orderLength: number;
  public orders: any = [];
  public preorderLength: number;
  public preorders: any = [];
  public requestAmount: number;

  public latestPendingDO: any;

  public services: any;

  public _sharedService = inject(SharedServiceService);
  public _authService = inject(AuthService);
  private _sharedMethods = inject(SharedMethodsModule);
  private dialog = inject(MatDialog);
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private router = inject(Router);
  private activatedRouter = inject(ActivatedRoute);
  private _webStorage = inject(WebStorage);
  private viewportScroller = inject(ViewportScroller);

  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;

  private customerBalanceResult: any;
  public customerBalance: number;
  public accountInArrears: boolean = false;

  private referrer: string;

  constructor (
    private _gtmService: GtmService,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedServiceService,

    @Inject(PLATFORM_ID) private platformId: any
  ) {

  }
 
  async ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

        const route = window.location.href;
        const path = this.router.url;

        this._gtmService.forgotPasswordPageReferrer = route;

        this._gtmService.pushEvent({ 
          event: 'page_view',
          page_url: route,
          page_path: path,
          page_title: 'dashboard_page',
          page_referrer: this.referrer ? this.referrer : route
        });
      }

      


    const fragment = this.activatedRouter.snapshot.fragment;
    if (fragment === 'orders') {
      setTimeout(() => {
        const element = document.getElementById(fragment);
        if (element) {
          const yOffset = -170;  
          const yPosition = element.getBoundingClientRect().top + window.scrollY + yOffset;
          this.viewportScroller.scrollToPosition([0, yPosition]);
        }
      }, 1000);
    }
 
    this.getCustomerDetails();   
    this.getTickets();
    this.getPendingDebitOrder(); 

    // if payment status is found in param
    if (this.activatedRouter.snapshot.queryParamMap.get('status')) {
      if (this.activatedRouter.snapshot.queryParamMap.get('status') == 'successful') {
          this.alert = {
            type: 'success',
            message: 'Your payment was successful!'
          }
          this.showAlert = true;
      }
    }
 
  }
  public async getCustomerDetails() {
    await this._sharedMethods.getCustomerAccount().then(async (res) =>{
      if (res.success) {
        this.customerAccount = res?.result;
        if (this.customerAccount) {
          await this._sharedMethods.getCustomerBalance(this.customerAccount?.EntityAccountEntityID)
            .then((res: any) => {
              if (res.result > 0) {
                this.accountInArrears = true;
                this._webStorage.CustommerAmountOutstanding.next(res.result)
              }
            });
          }
        } else {
          console.error('Error retrieving Customer Account', res);
        }
    });

    await this._sharedMethods.getCustomerLeadsArray().then((res)=>{
      this.addLeadStatusToService(res);
      res.forEach(element => {
        if(element?.LeadActionTypeCode === "Order"){
          this.orders.push(element);
        } else if (element?.LeadActionTypeCode === "PreOrder") {
          this.preorders.push(element);
        }
      });
      this.orderLength = this.orders?.length;
      this.preorderLength = this.preorders?.length;

    });
   
    const customerPayments = await this._sharedMethods.getCustomerPayments();
    const latestPaymentDetails = customerPayments?.result?.find((element)=> element.IsDefault === true && element.IsValidated);
    this._sharedService.customerPaymentMethod = latestPaymentDetails;
    this.validPayment = latestPaymentDetails ? true : false;  
    this.loading = false;
  }


 
  public speedTest(){
    this.dialog.open(SpeedTestComponent, {
      width: '800px',
      backdropClass: 'blurModalBackground'
    });
  }

  public openNetwork(){
    this.router.navigate(['/network/Fibre']);
  }

 
  public showAddon(showAddons){
    this.showAddons = !showAddons ;
  }


  public getServicesNumber(event: any){
    this.servicesLength = event;
  }

  public goToAnchor(fragment) {
    this.router.navigate([], { fragment: fragment });
  }

  public viewLatestDebitOrder() {
    this.dialog.open(MandatePopupComponent, {
          disableClose: true,
          width: '80vw',
          height: 'auto',
          backdropClass: 'blurModalBackground',
          panelClass: 'fuse-confirmation-dialog-panel',
          data: {
            mandateData: this.latestPendingDO
          }
        }).afterClosed().subscribe(() => {
          location.reload();
        })
  }

  private async addLeadStatusToService(leads: any) {
    //  ## GET SERVICES AND ADD LATEST LEAD ACTION STATUS, TO SERVICE ##
    await this._sharedMethods.getCustomerActiveServices().then((res: IResponse) => {
      let response = [];
      res?.result?.records?.forEach(element => {
        for (let index = 0; index < leads.length; index++) {
          let leadsData = leads[index];
          if (element?.EntityAccountOfferableEntityID == leadsData?.UpdatingEntityAccountOfferableID) {
            element.LeadActionTypeCode = leadsData?.LeadActionTypeCode;
            break;
          }   
        }
        response.push(element);
      });
      this.services = response;
     
    });
  }


  private async getTickets() {
    const allTicketsResult: any = await this._sharedMethods.getAllTickets();
    if (allTicketsResult?.success) {
      this.loading = false;
      this.requestAmount = allTicketsResult.result.total;   
  
    }
  }

  private async getPendingDebitOrder() {
    const latestPendingDO: any = await this._sharedMethods.getLatestPendingDO();
    if(latestPendingDO.success) {
      this.latestPendingDO = latestPendingDO.result;
    }
  }


  private async addIsFibreToOrder(order: any) {
    await this._sharedMethods.getLinkedOfferablesByLeadId(order.LeadEntityID).then((res: any) => {
      const linkedOfferables = res.result[0];

      const OfferableSubTypeName : string = linkedOfferables?.OfferableSubTypeName ?? linkedOfferables?.OfferableSubTypeName
      const OfferableName : string = linkedOfferables?.OfferableTypeName ?? linkedOfferables?.OfferableName

      let isFibre: boolean;

      const keywords = ['FTTH', 'Fibre'];

      if (
        keywords.some(keyword => OfferableSubTypeName?.includes(keyword)) || 
        keywords.some(keyword => OfferableName?.includes(keyword))
      ) 
       {
        isFibre = true
      } else {
        isFibre = false
      }

      order.isFibrePackage = isFibre;
      order.PackageName = linkedOfferables?.PackageName;
      order.OfferableSubTypeName = OfferableSubTypeName;
      order.OfferableName = OfferableName;
    })

  }




}
